module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"s3RegionAutocomplete.noRegionHint":"Please specify if your bucket is in a Chinese region."}}')
  delete Component.options._Ctor
}
